import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Grid,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Button,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import MainLogo from '../../Assets/images/openzklogo.png';
import ConnectButton from '../../WagmiProvider/ConnectButton';
import { isHidden } from '../../utils/constants';

let Routes = [
  {
    id: 1,
    pageName: 'Airdrop',
    route: '/airdrop',
    isSelected: false,
  },
  {
    id: 2,
    pageName: 'Bridge',
    route: '/bridge',
    isSelected: false,
  },
  {
    id: 3,
    pageName: 'Airdrop Claim',
    route: '/airdrop-claim',
    isSelected: false,
  },
  {
    id: 4,
    pageName: 'Vaults',
    route: '/vaults',
    isSelected: false,
  },
  {
    id: 5,
    pageName: 'Docs',
    route: 'https://docs.openzk.net/',
    isSelected: false,
  },
];

let routesFiltered = [
  {
    id: 1,
    pageName: 'Airdrop',
    route: '/airdrop',
    isSelected: false,
  },
  {
    id: 2,
    pageName: 'Bridge',
    route: '/bridge',
    isSelected: false,
  },
  {
    id: 4,
    pageName: 'Docs',
    route: 'https://docs.openzk.net/',
    isSelected: false,
  },
];

const TopNavBar = () => {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [Pages, setPages] = useState(isHidden ? routesFiltered : Routes);
  const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const currentPath = window.location.pathname;

  useEffect(() => {
    setPages(Pages);
  }, []);

  const handleRoute = (i, row) => {
    if (row?.pageName == 'Explorer') {
      window.open('https://openzk-testnet.explorer.caldera.xyz/', '_blank');
    } else {
      navigate(row.route);
    }
  };

  return (
    <Grid sx={{ display: 'flex' }} className="w-100" flexDirection={'column'}>
      <AppBar
        position="static"
        sx={
          currentPath == '/aboutus'
            ? { backgroundColor: '#000000' }
            : { backgroundColor: 'transparent' }
        }
        className="p-3 w-100 section-container shadow-none"
      >
        <Toolbar className="p-0" sx={{ paddingLeft: 0, paddingRight: 0 }}>
          <Grid
            container
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Grid
              item
              sm={1.5}
              xs={4}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <a href="https://www.openzk.net">
                <img
                  src={MainLogo}
                  alt="main_logo"
                  className="img-fluid "
                  style={{ cursor: 'pointer' }}
                />
              </a>
            </Grid>

            <Grid
              xs={6.5}
              sx={{
                display: { xs: 'flex', sm: 'none' },
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              <ConnectButton />
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>

              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                  '& .MuiMenu-paper': { backgroundColor: '#2a2438' },
                }}
              >
                {Pages.map((page, i) => (
                  <MenuItem
                    key={`${page.id}-${i}`}
                    sx={{ backgroundColor: '#2a2438' }}
                    onClick={handleCloseNavMenu}
                  >
                    {page.route.startsWith('https') ? (
                      <a
                        href={page.route}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="text-white text-center font-poppins uppercase cursor-pointer">
                          {page.pageName.toUpperCase()}
                        </span>
                      </a>
                    ) : (
                      <Typography
                        textAlign="center"
                        onClick={() => handleRoute(i, page)}
                      >
                        {page.pageName
                          ? page.pageName.toUpperCase()
                          : page.pageName}
                      </Typography>
                    )}
                  </MenuItem>
                ))}
              </Menu>
            </Grid>

            <Grid
              container
              sm={6.5}
              // display={"flex"}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'flex-start'}
              display={{ sm: 'flex', xs: 'none' }}
              className="pl-8"
              gap="40px"
            >
              {Pages?.map((page, i) => (
                <Grid
                  item
                  lg={
                    page?.pageName == 'Stake & Earn' ||
                    page?.pageName == 'Leaderboard' ||
                    page?.pageName == 'About Us' ||
                    page?.pageName == 'Airdrop Claim'
                      ? 2.6
                      : 1.5
                  }
                  key={i}
                >
                  {page.route.startsWith('https') ? (
                    <a
                      href={page.route}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="text-white text-[18px] text-center font-poppins cursor-pointer">
                        {page.pageName}
                      </span>
                    </a>
                  ) : (
                    <Button
                      key={`button-${page.id}-${i}`}
                      sx={{
                        color:
                          currentPath == page?.route ? '#FC9D4B' : '#ffffff',
                        cursor: 'pointer',
                        fontSize: '18px',
                        fontFamily: 'PoppinsRegular',
                        '&:hover': {
                          color: '#FC9D4B', // your hover color
                          textDecoration: 'underline',
                        },
                        transition: 'color 0.3s ease',
                        textTransform: 'none',
                        width: 'fit-content',
                      }}
                      onClick={() => handleRoute(i, page)}
                    >
                      {page.pageName}
                    </Button>
                  )}
                </Grid>
              ))}
            </Grid>

            <Grid
              item
              sm={3.3}
              sx={{ flexGrow: 0 }}
              display={{ sm: 'flex', xs: 'none' }}
            >
              <div className="nav navbar-nav ms-auto ml-auto">
                <ConnectButton />
              </div>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting, idx) => (
                  <MenuItem
                    key={`setting-${idx}`}
                    onClick={handleCloseUserMenu}
                  >
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Grid>
  );
};
export default TopNavBar;
